import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { AppContexte } from '../contexts/context'
import { logo } from '../constants/files'
import { adminActualityLink, adminEmissionLink, adminLink, adminMediaLink, adminProgrammeLink, adminUserLink } from '../constants/endspoints'
import { logoutUser } from '../api/auth'
import { storeData } from '../utils/local-storage-helper'

const Sidebar = () => {

    const { setSection, decodedToken, max, setMax } = useContext(AppContexte)

    const links =[
        {name: "Accueil", icon:"fa-light fa-house", path:adminLink, exact:true},
        {name: "Actualités", icon:"fa-light fa-newspaper", path:adminActualityLink},
        {name: "Emissions", icon:"fa-light fa-tv", path:adminEmissionLink},
        {name: "Programmation", icon:"fa-light fa-calendar-lines-pen", path:adminProgrammeLink},
        {
            name: decodedToken? decodedToken?.roles[0] === "ROLE_ADMIN"? "Utilisateurs" : "Mon compte" :"Mon compte",
            icon: decodedToken? decodedToken?.roles[0] === "ROLE_ADMIN"? "fa-light fa-users-gear" : "fa-light fa-user" :"fa-light fa-user", 
            path:adminUserLink
        },
        {name: "Media", icon:"fa-light fa-images", path:adminMediaLink},
    ]

    const style ={
        width : "75px"
    }

    const handleLogout = () =>{
        logoutUser()
    }

    return (
        <div className='d-flex position-relative'>
            <div className='sidebar d-none d-md-flex' style={!max?style:null}>
                <div className='sidebar-container'>
                    <div className='hide-arrow p-2' onClick={()=>{setMax(!max); storeData(!max,'sidebar')}}>
                        <button>
                            <span className='w-100 d-flex justify-content-center align-items-center'><i className={'d-flex fa fa-angle-left text-white'  + (max ? '' : ' fa-rotate-180')}></i></span>
                        </button>
                    </div>
                    <div className='sidebar-menu'>
                        <div className={'logo-brand '  + (max ? '' : 'ms-1 pt-3')}>
                            <div className='d-flex'>
                                <div className='d-inline-dlex flex-wrap'>
                                    <img src={logo} alt='logo UBIZ NEWS' className={'img-fluid ' + (max ? 'w-50' : 'w-75')} />
                                </div>
                            </div>
                        </div>
                        <div className='menu px-2'>
                            {
                                links.map((elt,index) =>{
                                    return(
                                        <div key={index} onClick={()=>setSection(elt.name)} className={'my-2 ' + (max ? '' : 'w-1')}>
                                            <NavLink end={elt?.exact} to={elt.path} activeclassname='active' className={'nav-link py-0 d-flex align-items-center rounded-2 py-1 px-2 ' + (max?'':'pe-0 justify-content-center py-3')}>
                                                <i className={ `${elt.icon} me-2 text-white ${max ? '' : 'fs-6'}`}></i>
                                                {max ? <span className='text-capitalize text-white fs-9s'> {elt.name} </span>: null}
                                            </NavLink>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className='log-out'>
                        <div onClick={handleLogout} className='d-flex flex-row text-white'>
                            <div className='my-4'>
                                <button activeclassname='active' className='py-0 d-flex align-items-center btn'>
                                    <i className={'fa-light fa-right-from-bracket me-2 text-white'}></i>
                                    {max ?<span className=' text-white text-capitalize fs-9s'> Se déconnecter </span>:null}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="offcanvas offcanvas-start w-auto bg-black text-white" id="submenu">
                <div className="offcanvas-header">
                    <div className='logo-brand'>
                        <div className='d-flex'>
                            <div className='d-inline-dlex flex-wrap'>
                                <img src={logo} alt='logo UBIZNEWS' className={'img-fluid w-50'} />
                            </div>
                        </div>
                    </div>
                    <div role='button' data-bs-dismiss="offcanvas"><i className="fa fa-xmark"></i></div>
                </div>
                <div className="offcanvas-body">
                    <div className='menu w-auto'>
                        {
                            links.map((elt,index) =>{
                                return(
                                    <div key={index} onClick={()=>setSection(elt.name)} data-bs-toggle="offcanvas" data-bs-target="#submenu" className={'my-3'}>
                                        <NavLink end={elt?.exact} to={elt.path} activeclassname='active' className={'nav-link py-0 d-flex align-items-center rounded-2 py-1 px-2 '}>
                                            <i className={ `${elt.icon} me-2 text-white`}></i>
                                            <span className='text-capitalize text-white fs-9s'> {elt.name} </span>
                                        </NavLink>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='bg-dark'>
                    <div className='log-out'>
                        <div onClick={()=>handleLogout()} className='d-flex flex-row text-light'>
                            <div className='my-3'>
                                <button activeclassname='active' className='ps-4 pe-5 nav-link py-0 btn d-flex align-items-center rounded-start-0 rounded-end-pill'>
                                    <i className={'fa-light fa-right-from-bracket me-2'}></i>
                                    {max ?<span className='pe-3 text-capitalize fs-9s'> Se déconnecter </span>:null}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
